module.exports = __webpack_public_path__ + "static/media/netresto-4.2e06b72a.png";